<script>
    import {elementDetails} from '../workspacesStore.js';
    import DataTable from '../../DataGrid/DataTable.svelte';
    import {sgettext} from '../../../i18n.js';
    import ReferenceDocumentColumn from './ReferenceDocumentColumn.svelte';
    import ShortenedUrlWithTooltipColumn from './ColumnRenderers/ShortenedUrlWithTooltipColumn.svelte'

    export let rows = $elementDetails ? $elementDetails.reference_documents : [];

    let columns = {
        document_reference: {
            label: sgettext('$$DOCUMENT_REFERENCE$$'),
            width: '30%'
        },
        document_name: {
            label: sgettext('$$DOCUMENT_NAME$$'),
            width: '30%'
        },
        document_description: {
            label: sgettext('$$DOCUMENT_DESCRIPTION$$'),
            renderer: ReferenceDocumentColumn,
            width: '30%',
            props:{
                'col' : 'document_description'
            }
        },
          document_url: {
            label: sgettext('$$DOCUMENT_URL$$'),
            renderer: ShortenedUrlWithTooltipColumn,
            width: '40%',
            props:{
                'col' : 'document_url'
            }
        }
    };

    let aggregatedColumns = {

    }
</script>

<DataTable
    small={true}
    {columns}
    {aggregatedColumns}
    {rows}
/>

